import {
  USER_STATE_CHANGE,
  IDBUSCAR_STATE_CHANGE,
  PESELECT_STATE_CHANGE,
  USER_LOADERROR_STATE_CHANGE,
  USER_ERRORSTATE_STATE_CHANGE,
  USER_RIGHTANEXOS_STATE_CHANGE,
  USER_LEFTANEXOS_STATE_CHANGE,
  USER_RIGHTANEXOS2_STATE_CHANGE,
  USER_LEFTANEXOS2_STATE_CHANGE,
  USER_FECTHINIT_STATE_CHANGE,
  USER_DATECHANGEFINAL_STATE_CHANGE,
  USER_DATECHANGEINICIO_STATE_CHANGE,
  USER_DATECHANGE_STATE_CHANGE,
  USER_DATEIN_STATE_CHANGE,
  USER_ENTRANTES_STATE_CHANGE,
  USER_SALIENTES_STATE_CHANGE,
  USER_TOKEN_STATE_CHANGE,
  USER_MENU_STATE_CHANGE,
  USER_TASK_STATE_CHANGE,
  USER_CLIENTID_CHANGE,
  ACTUALIZAR_LISTA,
  OPEN_REDUX,
  CLIENTES_REDUX,
  CLIENTES_REDUX_REPORT,
  CLEAR_DATA,
} from "../constanst/index";

const initialState = {
  currentUser: null,
  menu: [],
  task: [],
  entrantes: [],
  salientes: [],
  token: null,
  clientId: [],
  dateIn: [],
  dateChange: [],
  dateChangeFinal: {},
  dateChangeInicio: {},
  rightAnexos: [],
  leftAnexos: [],
  rightAnexos2: [],
  leftAnexos2: [],
  loadError: false,
  errorState: "",
  fetchInit: false,
  preselect: false,
  idBuscar: null,
  openRedux: false,
  actualizarLista: false,
  clientesRedux: [],
  clientesReduxReport: [],
};

export const user = (state = initialState, action) => {
  switch (action.type) {
    case USER_STATE_CHANGE:
      return {
        ...state,
        currentUser: action.currentUser,
      };
    case USER_DATEIN_STATE_CHANGE:
      return {
        ...state,
        dateIn: action.dateIn,
      };
    case USER_DATECHANGE_STATE_CHANGE:
      return {
        ...state,
        dateChange: action.dateChange,
      };
    case USER_DATECHANGEFINAL_STATE_CHANGE:
      return {
        ...state,
        dateChangeFinal: action.dateChangeFinal,
      };
    case USER_DATECHANGEINICIO_STATE_CHANGE:
      return {
        ...state,
        dateChangeInicio: action.dateChangeInicio,
      };
    case USER_TOKEN_STATE_CHANGE:
      return {
        ...state,
        token: action.token,
      };
    case USER_MENU_STATE_CHANGE:
      return {
        ...state,
        menu: action.menu,
      };
    case USER_TASK_STATE_CHANGE:
      return {
        ...state,
        task: action.task,
      };
    case USER_CLIENTID_CHANGE:
      return {
        ...state,
        clientId: action.clientId,
      };
    case USER_ENTRANTES_STATE_CHANGE:
      return {
        ...state,
        entrantes: action.entrantes,
      };
    case USER_SALIENTES_STATE_CHANGE:
      return {
        ...state,
        salientes: action.salientes,
      };
    case USER_FECTHINIT_STATE_CHANGE:
      return {
        ...state,
        fetchInit: action.fetchInit,
      };
    case USER_RIGHTANEXOS_STATE_CHANGE:
      return {
        ...state,
        rightAnexos: action.rightAnexos,
      };
    case USER_LEFTANEXOS_STATE_CHANGE:
      return {
        ...state,
        leftAnexos: action.leftAnexos,
      };
    case USER_RIGHTANEXOS2_STATE_CHANGE:
      return {
        ...state,
        rightAnexos2: action.rightAnexos2,
      };
    case USER_LEFTANEXOS2_STATE_CHANGE:
      return {
        ...state,
        leftAnexos2: action.leftAnexos2,
      };
    case PESELECT_STATE_CHANGE:
      return {
        ...state,
        preselect: action.preselect,
      };
    case USER_ERRORSTATE_STATE_CHANGE:
      return {
        ...state,
        errorState: action.errorState,
      };
    case USER_LOADERROR_STATE_CHANGE:
      return {
        ...state,
        loadError: action.loadError,
      };
    case IDBUSCAR_STATE_CHANGE:
      return {
        ...state,
        idBuscar: action.idBuscar,
      };
    case ACTUALIZAR_LISTA:
      return {
        ...state,
        actualizarLista: action.actualizarLista,
      };
    case OPEN_REDUX:
      return {
        ...state,
        openRedux: action.openRedux,
      };
    case CLIENTES_REDUX:
      return {
        ...state,
        clientesRedux: action.clientesRedux,
      };
    case CLIENTES_REDUX_REPORT:
      return {
        ...state,
        clientesReduxReport: action.clientesReduxReport,
      };
    case CLEAR_DATA:
      return initialState;

    default:
      return state;
  }
};
